import React, { useRef } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import flagSprite from '@lt/components/components/Flags';

import { useIntersectionObserver } from 'usehooks-ts';
import styles from './linksSection.module.css';

// Components:
import CountryList from './components/CountryList';
import ResortList from './components/ResortList';

// Types:
import type { IStateProps, ILinksSection } from './types';

type CustomCSSProperties = {
  '--textColor'?: string;
  '--linkColor'?: string;
};

type StyleProps = React.CSSProperties & CustomCSSProperties;

export const LinksSection = (props: ILinksSection & IStateProps) => {
  const {
    mapExpanded,
    modifierStyles,
    variant = 'default',
    isMetaregion = false,
    isMobile,
  } = props;

  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, { freezeOnceVisible: true });
  const isVisible = !!entry?.isIntersecting || isMetaregion;

  const isCountryList = ['default', 'countryList'].includes(variant);
  const isResortList = ['default', 'resortList'].includes(variant);

  return (
    <StyledContainer
      className={classnames(styles.container, {
        [styles.containerMobile]: isMobile,
        [styles.containerIsMetaregion]: isMetaregion,
        [styles.containerMobileOrMapExpanded]: isMobile || mapExpanded,
        [styles.containerMobileOrIsMetaregion]: isMobile || isMetaregion,
        [styles.containerMobileAndTextColor]:
          isMobile && modifierStyles?.textColor,
      })}
      style={
        {
          '--textColor': modifierStyles?.textColor,
          '--linkColor': modifierStyles?.linkColor,
        } as StyleProps
      }
      $isFlagSprite={isCountryList && isVisible}
      ref={ref}
    >
      {isCountryList && (
        <CountryList
          isMobile={isMobile}
          mapExpanded={mapExpanded}
          isMetaregion={isMetaregion}
        />
      )}
      {isResortList && <ResortList mapExpanded={mapExpanded} />}
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{
  $isFlagSprite: boolean;
}>`
  ${({ $isFlagSprite }) => ($isFlagSprite ? flagSprite() : '')}
`;
